export const capitalizeWords = (str) => {
  return str
    .toLowerCase()
    .split(' ')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
}

export const getDateRange = (rangeType) => {
  const dateStop = new Date();
  dateStop.setDate(dateStop.getDate() - 1); 
  const dateStart = new Date();

  switch (rangeType) {
      case '7day':
          dateStart.setDate(dateStop.getDate() - 7);
          break;
      case '1month':
          dateStart.setMonth(dateStop.getMonth() - 1);
          break;
      case '3month':
          dateStart.setMonth(dateStop.getMonth() - 3);
          break;
      default:
          throw new Error("Invalid range type. Use '7day', '1month', or '3month'.");
  }

  // Helper function to format date as YYYY-MM-DD
  const formatDate = (date) => date.toISOString().split('T')[0];

  return {
      dateStart: formatDate(dateStart),
      dateStop: formatDate(dateStop)
  };
}